module.exports = __webpack_public_path__ + "static/media/card-bg.8ce542b1.jpg";